<template>
  <div>
    <el-dialog
      :title="type==1?'退回':'撤销审批'"
      :visible.sync="dialogVisible"
      v-dialogDrag
      width="400px"
      :modal="true"
      :close-on-click-modal="false"
      :before-close="close"
    >
      <div>
        <el-row>
          <el-col :span="24">
            <span class="title">{{type==1?'退回原因':'撤销原因'}}</span>
            <el-input v-model="data.Remark" style="width:280px;" :placeholder="type==1?'请填写退回原因':'请填写撤销原因'"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm"  
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false"  >关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      dialogVisible: false,
      type: 1,
      data: {
        Remark: "",
      },
    }
  },
  methods: {
    open(data) {
      this.type = data;
      this.dialogVisible = true;
      this.data.Remark = "";
    },
    confirm() {
      if(!this.data.Remark) {
        this.$message.error("请填写原因");
        return
      }
      this.dialogVisible = false;
      this.$emit("confirm",this.data)
    },
    close() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-col{
  margin: 20px 0px 0 0;
}
.title{
  font-size: 14px;
  margin: 0px 10px 0 0;
}
.date{
  margin: 5px 0 0 76px;
  display: block;
}
/deep/ .el-dialog__body{
  padding-top: 0;
  padding-right: 10px;
}
</style>